import { useState, useEffect } from 'react';
import {
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/solid';
import { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';
import dayjs from 'dayjs';
import buildCalendar from './build';
import dayStyles, { createListingEndCalendarDayStyles } from './styles';
import { priceStyles } from './styles';
import { beforeToday, isNotInMonth } from './styles';

export default function CreateListingEndCalendar({ sel, setSel, listingMode }) {
  var badMutable = require('dayjs/plugin/badMutable');
  dayjs.extend(badMutable);
  var localizedFormat = require('dayjs/plugin/localizedFormat');
  dayjs.extend(localizedFormat);
  const [month, setMonth] = useState(dayjs());
  const [calendar, setCalendar] = useState([]);

  useEffect(() => {
    setCalendar(buildCalendar(month));
  }, [month]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  function prevMonth() {
    return month.clone().subtract(1, 'month');
  }

  function nextMonth() {
    if (
      dayjs(new Date(month.clone().add(1, 'month').format('YYYY-MM-DD'))).diff(
        dayjs(new Date()),
        'days',
      ) <= 60 ||
      listingMode === 'DIRECT'
    ) {
      return month.clone().add(1, 'month');
    }
    return month.clone();
  }

  function thisMonth() {
    return month.isSame(new Date(), 'month');
  }

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button className="text-gray-700 my-1 inline-flex w-full focus:z-10 items-center rounded-md border border-gray-300 shadow-sm px-2 py-2 bg-white text-sm font-medium hover:bg-gray-50 focus:border-blue-500 focus:border-2 focus:ring-opacity-50 focus:outline-none focus:ring-4 focus:ring-offset-gray-100 focus:ring-blue-500">
            <CalendarIcon
              className={classNames(
                open ? 'text-blue-400' : 'text-gray-400',
                'mr-2 h-5 w-5 group-hover:text-gray-500',
              )}
              aria-hidden="true"
            />
            <span>{sel.format('L')}</span>
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 -translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 -translate-y-1"
          >
            <Popover.Panel className="min-w-max origin-top-left absolute left-0 mt-1 bg-white rounded-xl border border-gray-300 shadow-lg z-10">
              {/* Calendar */}
              <div className="flex flex-col mx-auto p-3">
                <div className="flex items-center justify-between">
                  <button
                    onClick={() => (thisMonth() ? '' : setMonth(prevMonth()))}
                    type="button"
                    className="shadow-sm relative inline-flex items-center px-1 py-1 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <span className="sr-only">Previous</span>
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <span className="text-base font-medium text-gray-600">
                    {month.format('MMMM')}
                  </span>
                  <button
                    onClick={() => setMonth(nextMonth())}
                    type="button"
                    className="shadow-sm relative inline-flex items-center px-1 py-1 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <span className="sr-only">Next</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
                <div className="grid grid-cols-7 pb-1 mt-3 justify-center gap-1">
                  {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d) => (
                    <div className="flex-1 w-9 rounded-md text-base justify-center mx-auto text-center font-base text-gray-400">
                      {d}
                    </div>
                  ))}
                </div>
                <div className="grid grid-rows-1 gap-1 mx-auto">
                  {calendar.map((week) => (
                    <div className="grid grid-cols-7 gap-1">
                      {week.map((day) => (
                        <div
                          onClick={() =>
                            beforeToday(day) && isNotInMonth(day, month)
                              ? ''
                              : setSel(day)
                          }
                          className={`flex flex-col w-10 h-10 items-center justify-center text-center rounded-lg ${createListingEndCalendarDayStyles(
                            day,
                            sel,
                            month,
                            listingMode,
                          )}`}
                        >
                          <span className="flex justify-center content-center text-sm">
                            {day.format('D')}
                          </span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
